/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (ARS - Route Selections)
 🧩 Description:
    Form validation utilities for ARS module.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Validate ARS form
 */
export function validateForm(formData: FormState, t: (key: string) => string): Record<string, string> {
  const errors: Record<string, string> = {};
  const name = formData.name.trim();

  if (name.length === 0) {
    errors.name = t('ars.validation.nameRequired');
  } else if (name.length < 3) {
    errors.name = t('ars.validation.nameMinLength');
  }

  if (formData.routes.length === 0) {
    errors.routes = t('ars.validation.routeRequired');
  }

  formData.routes.forEach((route, index) => {
    if (!route.outboundRouteId) {
      errors[`route_${index}_outbound`] = t('ars.validation.outboundRouteRequired');
    }
  });

  return errors;
}

